import script from "./DocumentList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentList.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentList.vue?vue&type=style&index=0&id=479f0e10&scoped=true&lang=scss"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479f0e10"]])

export default __exports__